import * as React from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { AppMode } from '../../AppMode';
import { Candidate } from '../../Model/Candidate';
import { StaticSettings } from '../../StaticSettings';
import { FilterComponent } from '../Filter/FilterComponent';
import { FilterProps } from '../FilterProps';
import { TypeSwitcher } from '../TypeSwitcher';

export class FilterView extends React.Component<FilterProps<Candidate>> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    public render() {
        const props = this.props;
        const typeSwitcher = StaticSettings.ui.showTypeSwitcherTabs && StaticSettings.mode === AppMode.Both
            ? <TypeSwitcher activeType={props.type}/>
            : undefined;

        return <div className="job-center-filter-container">
            {typeSwitcher}
            <FilterComponent models={props.allModels}
                             type={props.type}
                             buttonTitle={this.context.i18n.translate("Kandidaten suchen")}
                             filterSettings={props.filterSettings}
                             onChange={props.onChange}
                             showSector={false}/>
        </div>;
    }
}
